// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

let fadeOptionsIn = {
  "duration":   500,
  "delay":      0
};

let fadeOptionsOut = {
  "duration":   200,
  "delay":      0
};

export function exhibitsbox_mouseIn(event, $w) {
	//Add your code for this event here: 
	$w('#exhibitboxarrow').show();
}

export function exhibitsbox_mouseOut(event, $w) {
	//Add your code for this event here: 
	$w('#exhibitboxarrow').hide();
}

export function ilbox_mouseIn(event, $w) {
	//Add your code for this event here: 
	$w('#ilboarrow').show();
}

export function ilbox_mouseOut(event, $w) {
	//Add your code for this event here: 
	$w('#ilboarrow').show();
}



